import module from 'colaborador/module.js'
import template from './template.html'

export class ColaboradorPrestamosExternosEliminarComponent {
  descuentoId
  deshabilitado
  onDelete
  eliminando = false

  cerrar($event) {
    this.eliminando = false

    if ($event.exito) {
      this.onDelete()
    }
  }
}

module.component('colaboradorPrestamosExternosEliminar', {
  controller: ColaboradorPrestamosExternosEliminarComponent,
  template,
  bindings: {
    descuentoId: '<',
    deshabilitado: '<',
    onDelete: '&',
  },
})


// WEBPACK FOOTER //
// ./src/colaborador/components/prestamosExternos/eliminar/component.js